import { Container } from "react-bootstrap";
import "./css/style.css";
import React, { useState, useEffect } from "react";
// import { InputMask } from "@react-input/mask";
import { MailGo } from "../../axi";

// function Cursor() {
//   const [x, setX] = useState(0);
//   const [y, setY] = useState(0);

//   const logMousePosition = (e) => {
//     setX(e.clientX);
//     setY(e.clientY);

//     e.target.setAttribute("style", "top: " + y + "px; left: " + x + "px;");
//   };

//   useEffect(() => {
//     return () => {
//       document.addEventListener("mousemove", logMousePosition);
//     };
//   }, []);

//   return <span></span>;
// }
export default function Footer(params) {
    // состояние данных формы
    const [formData, setFormData] = useState({
        name: "",
        tel: "",
    });
    //   состояние отправки
    const [formGo, setFormGo] = useState(false);

    //   обработка событий ввода и фиксирование их состояния
    const handleChange = (e) => {
        e.preventDefault();
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    // Обработчик отправки формы
    const handleSubmit = async (e) => {
        const form = e.currentTarget;

        if (form.checkValidity() === false) {
            e.preventDefault();
            e.stopPropagation();
        } else {
            e.preventDefault();

            const isLoggedIn = await MailGo(formData);

            if (isLoggedIn) {
                // Выполните действия, если вход успешен
                setFormGo(true);

                // Отправка цели в Яндекс.Метрику
                if (typeof window !== 'undefined' && window.ym) {
                    window.ym(99807460,'reachGoal','form_submitted');
                }

                setTimeout(() => {
                    setFormGo(false);
                }, 2000);
            } else {
                // Выполните действия, если вход неуспешен
            }
        }
    };

    /*МАСКА ДЛЯ НОМЕРА ТЕЛЕФОНА*/
    const getInputNumbersValue = function (input) {
        return input.value.replace(/\D/g, "");
    };
    const onPhonePaste = function (e) {
        let input = e.target,
            inputNumbersValue = getInputNumbersValue(input);
        let pasted = e.clipboardData || window.clipboardData;
        if (pasted) {
            let pastedText = pasted.getData("Text");

            if (/\D/g.test(pastedText)) {
                // Attempt to paste non-numeric symbol — remove all non-numeric symbols,
                // formatting will be in onPhoneInput handler
                input.value = inputNumbersValue;
                return;
            }
        }
    };
    const onPhoneKeyDown = function (e) {
        // Clear input after remove last symbol
        console.log("onPhoneKeyDown", e.keyCode);

        let inputValue = e.target.value.replace(/\D/g, "");
        if (e.keyCode === 8 && inputValue.length === 1) {
            e.target.value = "";
        }
    };
    const onPhoneInput = function (e) {
        let input = e.target,
            inputNumbersValue = getInputNumbersValue(input),
            selectionStart = input.selectionStart,
            formattedInputValue = "";

        if (!inputNumbersValue) {
            return (input.value = "");
        }

        if (input.value.length !== selectionStart) {
            // Editing in the middle of input, not last symbol
            if (e.data && /\D/g.test(e.data)) {
                // Attempt to input non-numeric symbol
                input.value = inputNumbersValue;
            }
            return;
        }

        if (["7", "8", "9"].indexOf(inputNumbersValue[0]) > -1) {
            if (inputNumbersValue[0] == "9") inputNumbersValue = "7" + inputNumbersValue;
            let firstSymbols = inputNumbersValue[0] == "8" ? "8" : "+7";
            formattedInputValue = input.value = firstSymbols + " ";
            if (inputNumbersValue.length > 1) {
                formattedInputValue += "(" + inputNumbersValue.substring(1, 4);
            }
            if (inputNumbersValue.length >= 5) {
                formattedInputValue += ") " + inputNumbersValue.substring(4, 7);
            }
            if (inputNumbersValue.length >= 8) {
                formattedInputValue += "-" + inputNumbersValue.substring(7, 9);
            }
            if (inputNumbersValue.length >= 10) {
                formattedInputValue += "-" + inputNumbersValue.substring(9, 11);
            }
        } else {
            formattedInputValue = "+" + inputNumbersValue.substring(0, 16);
        }
        input.value = formattedInputValue;
    };
    return (
        <>
            <section id="footer" className="footer">
                <Container className="">
                    <div className="footer_feedback">
                        <div className="footer_title">
                            <h2 className="block_title">
                                Оставьте заявку
                                <br />
                                на обратный звонок
                            </h2>
                            <img className="footer_title_arrow" src="img/footer/arrow.png" alt="стрелка" />
                        </div>

                        <form onSubmit={handleSubmit} onChange={handleChange} className="footer_form">
                            {formGo ? (
                                "Ваше сообщение успешно отправленно"
                            ) : (
                                <>
                                    <input type="text" placeholder="ИМЯ*" name="name" required />
                                    <input
                                        onInput={onPhoneInput}
                                        onKeyDown={onPhoneKeyDown}
                                        onPaste={onPhonePaste}
                                        required
                                        class="form__input form__input--tel js-req popup_phone"
                                        data-tel-input
                                        id="phoneInput"
                                        name="tel"
                                        type="tel"
                                        placeholder="+7 (___) ___-__-__"
                                        maxlength="18"
                                    />
                                    <button className="footer_form_button flex t16" type="submit">
                                        перезвоните мне
                                    </button>
                                </>
                            )}
                        </form>
                    </div>
                    <div className="footer_logo_inform">
                        <a href="#" className="footer_logo">
                            <img className="footer_logo_img" alt="логотип" src="/img/footer/logo.png"></img>
                        </a>
                        <div className="footer_inform">
                            <div className="footer_inform_services a">
                                <p className=" t16">Услуги</p>
                                <a href="#services">Уличные экраны</a>
                                <a href="#services">Экраны для помещения</a>
                                <a href="#services">Видеопилоны</a>
                                <a href="#services">Экраны для сцены</a>
                                <a href="#services">Экраны на фасаде</a>
                                <a href="#services">Экраны на остановке</a>
                            </div>
                            <div className="footer_inform_menu b">
                                <a href="#advantages" role="button" className=" t16">
                                    Преимущества
                                </a>
                                <a href="#kwiz" role="button" className=" t16">
                                    Рассчитать стоимость
                                </a>
                                <a href="#reviews" role="button" className=" t16">
                                    Отзывы
                                </a>
                            </div>
                            <div className="footer_inform_contacts c">
                                <a className="footer_inform_contacts_number" href="tel:+79278223311">
                                    +7-927-822-33-11
                                </a>
                                <a
                                    className="footer_inform_contacts_address"
                                    href="https://yandex.ru/maps/195/ulyanovsk/house/ulitsa_uritskogo_29b/YEEYdQBgSUQGQFtufX9ycXlqZQ==/?ll=48.370011%2C54.330591&source=serp_navig&z=17">
                                    г. Ульяновск, ул. Урицкого 29Б
                                </a>
                                <a className="footer_inform_contacts_whatsapp" href="https://api.whatsapp.com/send?phone=79278223311">
                                    <p>Связаться в WhatsApp</p>
                                    <img src="img/footer/small_arrow.png" alt="стрелка" />
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className="footer_logo_inscriptions">
                        <p>© «СимЭкран» 2025</p>
                        <p className="footer_general_information">ООО "РАСПП-УЛ" ИНН: 7300004168 ОГРН: 1227300007880</p>
                        <p>
                            Разработка сайта:&nbsp;&nbsp;
                            <span className="footer_agatech">AGATECH</span>
                        </p>
                    </div>
                </Container>
            </section>
        </>
    );
}
